'use strict';

import { Entity } from '../Entity';

export class AgencyAgentNpn extends Entity {
  protected npnId;

  protected user;

  protected npn;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.npnId = data.npnId;

    this.user = data.user;

    this.npn = data.npn;
  }

  public getNpnId() {
    return this.npnId;
  }

  public getUser() {
    return this.user;
  }

  public getNpn() {
    return this.npn;
  }
}
